import React from "react";
import { useNavigate } from "react-router-dom";
import { flushSync } from "react-dom";
import { Lightbulb, TrendUp } from "@phosphor-icons/react";
import CompassLayout from "@/components/compass/CompassLayout";
import BigCard from "@/components/compass/BigCard";
import { useCompass } from "@/context/CompassContext";
import { useAuth } from "@/context/AuthContext";
import LocationBadge from "@/components/LocationBadge";

export default function CompassHome() {
  const nav = useNavigate();
  const { update, reset } = useCompass();
  const { user } = useAuth();
  const firstName = (user?.name || "").split(" ")[0];
  const city = user?.city;

  const choose = (path) => {
    // Fresh flow: wipe any previous draft, then set path atomically.
    flushSync(() => { reset(); update({ path }); });
    nav("/brujula/pais");
  };

  return (
    <CompassLayout testid="page-compass-home">
      <div className="mb-6">
        <div className="label-mono text-muted-foreground flex items-center gap-2 flex-wrap">
          <span>Brújula</span>
          <span aria-hidden>·</span>
          <LocationBadge variant="tag" testid="brujula-home-location-badge" />
        </div>
        {firstName && (
          <p className="mt-3 text-sm font-semibold uppercase tracking-wider text-muted-foreground" data-testid="brujula-welcome-line">
            Bienvenido a Ruta, {firstName}.
          </p>
        )}
        <h1 className="display text-3xl sm:text-4xl md:text-5xl mt-2 leading-[0.95]">
          {city
            ? <>Vamos a construir en <span className="whitespace-nowrap">{city}</span>.</>
            : "¿Dónde te encuentras hoy?"}
        </h1>
        <p className="mt-3 text-base text-muted-foreground max-w-lg leading-relaxed">
          Antes de avanzar, ayudemos a identificar el mejor camino para ti.
        </p>
      </div>

      <div className="flex flex-col gap-5">
        <BigCard
          accent="blue"
          Icon={Lightbulb}
          title="Tengo una Idea"
          description="Quiero emprender, pero necesito ayuda para encontrar el mejor camino."
          cta="Explorar Mi Idea"
          onClick={() => choose("idea")}
          testid="compass-card-idea"
        />
        <BigCard
          accent="green"
          Icon={TrendUp}
          title="Ya Tengo un Negocio"
          description="Quiero mejorar, organizar, crecer o resolver problemas en mi negocio actual."
          cta="Analizar Mi Negocio"
          onClick={() => choose("negocio")}
          testid="compass-card-negocio"
        />
      </div>

      <div className="mt-10 brut-card !p-4">
        <div className="label-mono text-muted-foreground">¿Cómo funciona?</div>
        <p className="mt-2 text-sm leading-relaxed">
          La Brújula evalúa <strong>oportunidad × persona × recursos × entorno × timing</strong> para
          responder <em>¿voy por el camino correcto?</em> antes de que empieces a ejecutar.
        </p>
      </div>
    </CompassLayout>
  );
}
